import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, UserCheckIcon, CalendarIcon, DollarSignIcon, GlobeIcon, ShieldIcon, MapPinIcon } from 'lucide-react';
export const BenefitsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('benefits');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const studentBenefits = [{
    icon: <UserCheckIcon className="h-6 w-6 text-blue-600" data-id="element-531" />,
    title: 'Qualified Music Educators',
    description: 'Discover teachers with clear profiles, experience, and teaching focus—designed to make choosing the right mentor easier.'
  }, {
    icon: <MapPinIcon className="h-6 w-6 text-blue-600" data-id="element-532" />,
    title: 'Local & Online Learning',
    description: 'Find teachers offering online or in-person lessons based on your learning preferences, as discovery features roll out.'
  }, {
    icon: <GlobeIcon className="h-6 w-6 text-blue-600" data-id="element-533" />,
    title: 'A Better Learning Experience',
    description: 'A modern platform built to support long-term learning, communication, and progress tracking.'
  }];
  const teacherBenefits = [{
    icon: <DollarSignIcon className="h-6 w-6 text-blue-600" data-id="element-534" />,
    title: 'No Hidden Fees',
    description: 'Simple, transparent subscription pricing with no commission on your lesson rates.'
  }, {
    icon: <ShieldIcon className="h-6 w-6 text-blue-600" data-id="element-535" />,
    title: 'Stay in Control',
    description: 'Manage your lessons, availability, students, and teaching workflow in one place—without relying on generic tools.'
  }, {
    icon: <CheckCircleIcon className="h-6 w-6 text-blue-600" data-id="element-536" />,
    title: 'Professional Presence',
    description: 'Create a polished teacher profile with your experience, instruments, and teaching approach—built to grow as the platform expands.'
  }];
  return <section id="benefits" className="py-24 bg-lavender/10" data-id="element-537">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-538">
        <div className="text-center mb-16" data-id="element-539">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-540">
            Benefits for Everyone
          </h2>
          <p className="text-lg text-white max-w-2xl mx-auto" data-id="element-541">
            Our platform is designed to create the best experience for both
            students and teachers.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-542">
          <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-543">
            <div className="bg-white rounded-xl p-8 shadow-sm h-full" data-id="element-544">
              <h3 className="text-2xl font-bold text-navy-900 mb-6 flex items-center" data-id="element-545">
                For Teachers
              </h3>
              <div className="space-y-6" data-id="element-546">
                {teacherBenefits.map((benefit, index) => <div key={index} className="flex" data-id="element-547">
                    <div className="flex-shrink-0 mt-1" data-id="element-548">{benefit.icon}</div>
                    <div className="ml-4" data-id="element-549">
                      <h4 className="text-lg font-medium text-navy-900" data-id="element-550">
                        {benefit.title}
                      </h4>
                      <p className="text-gray-600" data-id="element-551">{benefit.description}</p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
          <div className={`transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-552">
            <div className="bg-white rounded-xl p-8 shadow-sm h-full" data-id="element-553">
              <h3 className="text-2xl font-bold text-navy-900 mb-6 flex items-center" data-id="element-554">
                For Students (Coming Soon)
              </h3>
              <div className="space-y-6" data-id="element-555">
                {studentBenefits.map((benefit, index) => <div key={index} className="flex" data-id="element-556">
                    <div className="flex-shrink-0 mt-1" data-id="element-557">{benefit.icon}</div>
                    <div className="ml-4" data-id="element-558">
                      <h4 className="text-lg font-medium text-navy-900" data-id="element-559">
                        {benefit.title}
                      </h4>
                      <p className="text-gray-600" data-id="element-560">{benefit.description}</p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};